<template>
    <div>
        <div class="header">
            <div class="tuichu">
                <el-dropdown trigger="click" @command="out">
                      <span class="el-dropdown-link">
                        {{userInf.Username}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="mymenu">
            <el-scrollbar style="height:100%" wrap-style="overflow-x:hidden;">
                <a class="logo"></a>
                <dl v-for="(x,index) in menu" v-if="x.meta.showMenu!==false && userInf.userType==x.meta.userType" :key="index">
                    <router-link :to="{name:x.name}" v-if="!x.meta.link" tag="dt"><i :class="x.meta.icon"></i><b>{{x.meta.title}}</b><span :class="{'el-icon-arrow-down':$router.history.current.matched[0].name==x.name,'el-icon-arrow-up':$router.history.current.matched[0].name!=x.name
    }"></span></router-link>
                    <dt v-if="x.meta.link"><a :href="x.meta.link" target="_blank"><i :class="x.meta.icon"></i><b>{{x.meta.title}}</b><span :class="{'el-icon-arrow-down':$router.history.current.matched[0].name==x.name,'el-icon-arrow-up':$router.history.current.matched[0].name!=x.name
    }"></span></a></dt>
                    <router-link :to="{name:b.name}" tag="dd" v-for="(b,index) in x.children" v-if="b.meta.showMenu!==false" :key="index"><b>{{b.meta.title}}</b></router-link>
                </dl>
            </el-scrollbar>
        </div>
        <div class="main">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "frame",
        data(){
            return{
                menu:[],
                userInf:{}
            }
        },
        mounted() {
            let userInf=localStorage.getItem('userInf');
            if(!userInf){
                if(process.env.NODE_ENV=='development'){
                    this.$router.push({name:'login'});
                }else{
                    if(this.$route.query.jump){
                        location.href='../login.shtml?url='+this.$route.query.jump;
                    }else{
                        location.href='../login.shtml';
                    }
                }
            }else{
                this.userInf=JSON.parse(localStorage.getItem('userInf'));
                this.menu=this.$router.options.routes;
            }
            this.watchWidth();
            this.size();
        },
        methods:{
            //安全退出
            out:function () {
                if(process.env.NODE_ENV=='development'){
                    this.http.loginout()
                        .then(res=>{
                            localStorage.setItem('userInf',"");
                            this.$router.push({name:'login'});
                        })
                    ;
                }else{
                    this.http.loginout()
                        .then(res=>{
                            localStorage.setItem('userInf',"");
                            window.location.href='../login.shtml';
                        })
                    ;
                }
                return false
            },
            //监听页面大小
            size:function () {
                let _this=this;
                window.onresize=function(){
                    _this.watchWidth()
                }
            },
            watchWidth:function () {
                let width=window.innerWidth;
                if(width<=1440){
                    document.getElementsByTagName('body')[0].classList.add('small');
                }else{
                    document.getElementsByTagName('body')[0].classList.remove('small');
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/frame.vue